import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import paths from '../constants/routes.json';
import Account from '../containers/Account';
import Activities from '../containers/Activities';
import Listings from '../containers/Listings';
import ListingDetails from '../containers/Listings/ListingDetails';
import Contacts from '../containers/Listings/Details/Contacts';
import Overview from '../containers/Overview';
import People from '../containers/People';
import ContactDetails from '../containers/People/ContactDetails';
import Support from '../containers/Support';

const ContentRoutes = () => {
  return (
    <Switch>
      <Route path={paths.ACCOUNT} component={Account} />
      <Route path={paths.ACTIVITIES} component={Activities} />
      <Route
        path={`${paths.PEOPLE}/:contactId/:listingId`}
        component={ContactDetails}
      />
      <Route
        path={`${paths.PEOPLE}/new/:listingId`}
        component={ContactDetails}
      />
      <Route path={`${paths.PEOPLE}/:contactId`} component={ContactDetails} />
      <Route path={paths.PEOPLE} component={People} />
      <Route path={paths.OVERVIEW} component={Overview} />
      <Route path={`${paths.LISTINGS}/:listingId`} component={ListingDetails} />
      <Route path={paths.LISTINGS} component={Listings} />
      <Route path={paths.SUPPORT} component={Support} />
      <Redirect from="/" to="/overview" />
    </Switch>
  );
};

export default ContentRoutes;
